//require('../kendo.core.js');

(function ($, undefined$1) {

    /* CUSTOM (NOT INCLUDED IN THE RELEASE FROM KENDO) */
    /* ----------------------------------------------- */
    /* Calendar */

    if (kendo.ui.Calendar) {
        kendo.ui.Calendar.prototype.options.messages =
            $.extend(true, kendo.ui.Calendar.prototype.options.messages, {
                "today": "vandaag",
                "parentViews": {
                    "decade": "10 jaar",
                    "month": "maand",
                    "year": "jaar"
                },
                "navigateTo": "Navigeer naar"
            });
    }

    /* ----------------------------------------------- */

})(window.kendo.jQuery);
